import React from 'react';
import dynamic from 'next/dynamic';
import { Modal } from '../../components/Modal/Modal';
import { Button } from '@husslehq/ui-library';

const ImageGallery = dynamic(import('react-image-gallery'));

import styles from '../../components/ImageCarouselGallery/ImageCarouselGallery.module.scss';

export interface IGalleryImage {
  original: string;
  thumbnail: string;
}

export type ImageCarouselGalleryProps = {
  galleryData: IGalleryImage[];
  onClose: () => void;
  modalVisible: boolean;
  startIndex: number;
};

export const ImageCarouselGallery: React.FC<ImageCarouselGalleryProps> = ({
  galleryData,
  onClose,
  modalVisible,
  startIndex,
}) => {
  return (
    <div className={styles['image-gallery__container']}>
      <Modal
        visible={modalVisible}
        shouldCloseOnOverlayClick={true}
        shouldCloseOnEsc={true}
        onRequestClose={onClose}
        overlayClassName="gallery-modal-overlay"
        modalClassName="gallery-modal"
        contentClassName={styles['image-gallery__modal-content']}
      >
        <Button level="outline" className={styles['image-gallery__back-btn']} onClick={onClose}>
          Back to Gym Details
        </Button>
        <ImageGallery items={galleryData} showPlayButton={false} showFullscreenButton={false} startIndex={startIndex} />
      </Modal>
    </div>
  );
};

export { ImageCarouselGallery as default };
